import { FC, useEffect } from 'react';

type PolicyProps = {
  policyKey?: string;
};

const termageddonAPIPath = 'https://app.termageddon.com/api/policy/';

/** Loads hosted legal policy HTML from Termageddon by policy key. */
export const Policy: FC<PolicyProps> = ({ policyKey }) => {
  useEffect(() => {
    const policy = document.getElementById('policy');
    if (policy === null || policyKey === undefined) {
      return;
    }

    const polExtra = policy.dataset.extra ? `?${policy.dataset.extra}` : '';
    const xhr = new XMLHttpRequest();

    xhr.onload = () => {
      policy.innerHTML = xhr.responseText;
    };

    xhr.onerror = () => {
      policy.innerHTML = 'There has been an error loading this policy!';
    };

    xhr.open('GET', `${termageddonAPIPath}${policyKey}${polExtra}`);
    xhr.send();
  }, [policyKey]);

  return (
    <div className="mx-auto mb-auto p-10 font-open-sans text-xs text-primaryDark-200/80">
      <div
        id="policy"
        data-extra="h-align=left&h-depth=3&table-style=accordion"
        style={{ whiteSpace: 'pre-line', lineHeight: '1.2' }}
      />
    </div>
  );
};

export default Policy;
